import React from 'react';
import c from 'classnames';
import s from './NewBadge.scss';
const NewBadge = ({ className  })=>{
    return /*#__PURE__*/ React.createElement("img", {
        loading: "lazy",
        alt: "new",
        className: c(s['root'], className),
        src: "https://st.deviantart.net/eclipse/promos/newtag.svg"
    });
};
NewBadge.displayName = 'NewBadge';
export default NewBadge;
